import React, { createContext, useState, useContext, useCallback } from 'react';
import { usersAPI } from '../services/api';

const MLMContext = createContext();

export const useMLM = () => {
  const context = useContext(MLMContext);
  if (!context) throw new Error('useMLM debe usarse dentro de MLMProvider');
  return context;
};

export const MLMProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadProfile = useCallback(async () => {
    setLoading(true);
    try {
      const res = await usersAPI.getMe();
      setProfile(res.data);
    } catch {
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const value = { profile, loading, loadProfile };

  return <MLMContext.Provider value={value}>{children}</MLMContext.Provider>;
};
